'use strict';

//require('friartux/components/datepicker');

const createErrorNotification = require('./errorNotification');
const urlHelper = require('friartux/utils/urlHelper');
const { CLASSES } = require('friartux/utils/globals');
const datepicker = require('friartux/components/datepicker');

const customerPurchasePurpose = {
    EVENT: 'event',
    PERSONAL: 'personal'
}

const SELECTORS = {
    body: 'body',
    customerPurposeModal: '#customerPurposeModal',
    eventDateModal: '#eventDateModal',
    dateInput: '.js-input-date',
    eventCustomerPurposeForm: '.js-event-purpose-form',
    eventPurposeSelect: '.js-purpose-select',
    activeEventPurposeSelect: '.js-purpose-select.active',
    modalContent: '.modal.show .modal-content',
    modalBodyContent: '.js-modal-body-content',
    modalTitle: '.modal-title',
    addToCartCTA: '.js-add-to-cart-modal',
    eventPurposeError: '.js-event-purpose-error',
    addToCartButton: '.js-add-to-cart-modal',
    activeAddToCartButton: '.ecom-buttons-container .active .js-add-to-cart-modal, .ecom-buttons-container .active .add-to-cart',
    generalErrorContainer: '.error-messaging',
    purchaseOption: '.purchase-option .option-btn.active',
    buyButton: '.ecom-buttons-container .buyContainer .btn-purchase-container button',
    rentButton: '.ecom-buttons-container .rentContainer button',
    modalTrigger: '.js-modal-trigger',
    miniCart: '.js-minicart-link',
    plpEventDateButton: '.js-plp-event-date-btn'
}

/**
 * Init page events
 * @returns {void}
 */
function init() {
    $(SELECTORS.eventCustomerPurposeForm).on('submit', eventCustomerPurposeFormSubmit);
    $(SELECTORS.body).on('click', SELECTORS.eventPurposeSelect, handlePurposeSelect)
    $(SELECTORS.body).on('keydown', SELECTORS.eventPurposeSelect, handlePurposeKeydown)
    $(SELECTORS.body).on('show.bs.modal', SELECTORS.customerPurposeModal, handleCustomerPurposeModalOpen);
}

/**
 * Arrow-key navigation for the purpose radiogroup (WCAG radio pattern).
 *
 * @param {*} e - Keydown event
 */
const handlePurposeKeydown = (e) => {
    const navKeys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
    if (navKeys.indexOf(e.key) === -1) {
        return;
    }
    e.preventDefault();

    const $radios = $(SELECTORS.eventPurposeSelect);
    const currentIndex = $radios.index(e.currentTarget);
    const forward = e.key === 'ArrowDown' || e.key === 'ArrowRight';
    const nextIndex = (currentIndex + (forward ? 1 : -1) + $radios.length) % $radios.length;

    $radios.eq(nextIndex).trigger('click').focus();
}

/**
 * Handle Customer Purpose Form Submit.
 * Send Ajax to Search-SetCustomerPurpose Controller
 *
 * @returns {void}
 */
const eventCustomerPurposeFormSubmit = (e) => {
    e.preventDefault();
    const $form = $(e.target);
    let eventPurpose = SELECTORS.eventPurposeSelect + '.' + CLASSES.active;

    if ($(eventPurpose).length <= 0) {
        $(SELECTORS.eventPurposeError).removeClass(CLASSES.hide);
        return false;
    }

    $(SELECTORS.modalContent).spinner().start();
    const customerPurpose = $(SELECTORS.activeEventPurposeSelect).data('value');
    let url = urlHelper.appendToUrl($form.attr('action'), {
        customerPurpose: customerPurpose
    });

    $.ajax({
        url: url,
        dataType: 'json',
        success:  function (response) {
            if (response.success) {
                $(SELECTORS.modalContent).spinner().stop();

                // Update js site preferences.
                if (SitePreferences && response.orderThreshold) {
                    SitePreferences.ORDER_THRESHOLD = response.orderThreshold;
                }

                updateMiniCartLink(customerPurpose);
                updateEventModal(response, customerPurpose);
                updateAddToCart(customerPurpose);
                updatePlp();

                $(SELECTORS.customerPurposeModal).modal('hide');
            }
        },
        error: function (err) {
            createErrorNotification($(SELECTORS.generalErrorContainer), err.responseJSON.message);
            $(SELECTORS.modalContent).spinner().stop();
        }
    });
}

/**
 * Handles the customer purpose selection.
 *
 * @param {*} e - Event
 */
const handlePurposeSelect = (e) => {
    let $this = $(e.currentTarget);
    $(SELECTORS.eventPurposeSelect)
        .removeClass(CLASSES.active)
        .attr('aria-checked', 'false')
        .attr('tabindex', '-1');
    $this
        .addClass(CLASSES.active)
        .attr('aria-checked', 'true')
        .attr('tabindex', '0');
    $(SELECTORS.eventPurposeError).addClass(CLASSES.hide);
}

/**
 * Handles the customer purpose modal open event.
 *
 * @param {*} e - Event
 */
const handleCustomerPurposeModalOpen = (e) => {
    let triggerModalClass = 'js-modal-trigger';
    // Remove the previous trigger modal class.
    $(SELECTORS.modalTrigger).removeClass(triggerModalClass);

    var triggerElement = e.relatedTarget;
    $(triggerElement).addClass(triggerModalClass);
    $(SELECTORS.customerPurposeModal).find(SELECTORS.modalTitle).text(`${Resources.EVENT_HEADER_PURPOSE}`);
}

/**
 * Update the add to cart button.
 *
 * @param {*} customerPurpose - Submitted customer purchase purpose.
 */
const updateAddToCart = (customerPurpose) => {
    if (customerPurpose == customerPurchasePurpose.PERSONAL) {
        // Update the buy add product to cart button to not show
        // the event location and event date modal.
        $(SELECTORS.buyButton)
            .removeAttr('data-target')
            .removeAttr('data-toggle')
            .removeClass('js-add-to-cart-modal')
            .addClass('add-to-cart');

        // Update the rent add to cart button to show event datepicker.
        $(SELECTORS.rentButton)
            .attr('data-target', '#eventDateModal');
    } else {
        // Show the event location and date modal.
        $(SELECTORS.addToCartButton).attr('data-target', '#eventDateModal');
    }

    triggerAddToCart(customerPurpose);
}

/**
 * Trigger the add to cart button.
 *
 * @param {*} customerPurpose - Submitted customer purchase purpose.
 * @returns
 */
const triggerAddToCart = (customerPurpose) => {
    let triggeredByMiniCart = $(SELECTORS.modalTrigger).hasClass('minicart-link');

    if (triggeredByMiniCart) {
        return;
    }

    $(SELECTORS.activeAddToCartButton).trigger('click');

    if (customerPurpose == customerPurchasePurpose.PERSONAL) {
        // Reinitialize the date picker.
        $(SELECTORS.body).trigger('inputDate:reInit');
        $(SELECTORS.body).trigger('inputDate:open', $(SELECTORS.modalContent));
    }

}

/**
 * Update the Event date modal based on the customer purpose.
 *
 * @param {*} response
 * @param {*} customerPurpose - Submitted customer purchase purpose.
 */
const updateEventModal = (response, customerPurpose) => {
    // Update modal to show event datepicker only for rent
    // purchase option.
    if (customerPurpose == customerPurchasePurpose.PERSONAL && response.renderedTemplate) {
        $(SELECTORS.eventDateModal)
            .find(SELECTORS.modalBodyContent)
            .html(response.renderedTemplate);

        $(SELECTORS.eventDateModal)
            .find(SELECTORS.modalTitle)
            .text(`${Resources.EVENT_HEADER_WHEN}`);
    }

}

/**
 * Update the minicart link
 *
 * @param {*} customerPurpose - Submitted customer purchase purpose.
 */
const updateMiniCartLink = (customerPurpose) => {
    if (customerPurpose == customerPurchasePurpose.PERSONAL) {
        // No dialog left to open, so the control goes back to being a plain link to the cart.
        $(SELECTORS.miniCart)
            .removeAttr('data-target')
            .removeAttr('data-toggle')
            .removeAttr('role')
            .removeAttr('aria-haspopup');
    } else {
        // Update the minicart link modal target.
        $(SELECTORS.miniCart)
            .attr('data-target', '#eventDateModal');

        // Only a minicart that still toggles a modal opens a dialog instead of navigating, so
        // only that one exposes the button role (WCAG 4.1.2). This also runs when the purpose
        // modal was opened from add to cart, while the minicart may be a plain link to the cart.
        $(SELECTORS.miniCart)
            .filter('[data-toggle="modal"]')
            .attr('role', 'button')
            .attr('aria-haspopup', 'dialog');
    }

    let triggeredByMiniCart = $(SELECTORS.modalTrigger).hasClass('minicart-link');
    if (triggeredByMiniCart) {
        if (customerPurpose == customerPurchasePurpose.PERSONAL) {
            // Redirect to cart page.
            window.location = $(SELECTORS.miniCart).attr('href');
        } else {
            // Update the minicart link modal target.
            $(SELECTORS.miniCart).trigger('click');
        }
    }
}

function updatePlp() {
    if ($(SELECTORS.plpEventDateButton).length <= 0) {
        return;
    }

    datepicker.reInit();
    $(SELECTORS.plpEventDateButton)
        .addClass('title')
        .removeClass('js-modal-trigger')
        .removeAttr('data-toggle')
        .removeAttr('data-target');

    // Open the calendar
    $(SELECTORS.plpEventDateButton).trigger('click');
}

module.exports = {
    init: init
};
